
(function ($) {
  $(".js-featured-media__fitvid").fitVids();
})(jQuery);


